import { Box } from '@wix/design-system';
import React from 'react';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { Collapse, ToggleCollapsibleButton, useCollapse } from '../../Collapse';
export const ProductCardContent = ({ children, ...props }) => {
    return (React.createElement(ProductCardCollapsibleContent, { ...props, collapsible: false, isOpen: true }, children));
};
export const ProductCardCollapsibleContent = ({ children, collapsible: collapsibleEnabled, labels, isOpen: isOpenDefault = true, onToggle, ...props }) => {
    const isMobile = useIsMobile();
    const isCollapsible = collapsibleEnabled !== undefined ? collapsibleEnabled : isMobile;
    const { isOpen, toggleCollapse } = useCollapse({
        isOpen: isOpenDefault,
        collapsible: isCollapsible,
    });
    return (React.createElement(Box, { direction: "vertical", width: "100%", align: "center", ...props }, isCollapsible ? (React.createElement(React.Fragment, null,
        React.createElement(Collapse, { isOpened: isOpen }, children),
        React.createElement(ToggleCollapsibleButton, { isOpen: isOpen, labels: labels, collapsible: isCollapsible, onToggle: toggleCollapse }))) : (React.createElement(React.Fragment, null, children))));
};
//# sourceMappingURL=ProductCardContent.js.map